import { useDispatch, useSelector } from 'react-redux';

import EditItem from '../../../../shared/components/IconButtons/EditItem';
import CampoInputTexto from '../../../../shared/components/CampoInputComButton/CampoInputTexto/CampoInputTexto';
import { handleOcorrenciaChange } from '../../../../../store/reducers/ocorrenciaSlice';

const CampoInputNomeCliente = ({ onClick, editButton, disabled }) => {

    const dispatch = useDispatch()
    const { client } = useSelector(state => state.ocorrenciaState)
    
    const handleChange = (name, value) => {
        dispatch(handleOcorrenciaChange({[name]: value}))
    }
    const handleClick = (e) => {
        e.preventDefault()
        onClick("client")
    }

    return (
        <CampoInputTexto
            id="inputNomeCliente"
            titulo="Nome cliente*"
            onChange={handleChange}
            name="client"
            required
            value={client}
            disabled={disabled}
        >
            {
                editButton ? <EditItem onClick={handleClick} /> : <></>
            }
        </CampoInputTexto>
    )
}

export default CampoInputNomeCliente
